var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPictoUltra(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5264 17.7651L42.1833 15.1768H61.1334L64.8964 17.4844M65.1251 19.7921V18.1601C65.1251 17.9418 64.9484 17.7651 64.7405 17.7651H37.9214C37.7031 17.7651 37.5368 17.9418 37.5368 18.1601V19.7921M65.1251 19.7921H37.5264V94.2204M65.1251 19.7921V94.2204H37.5264M37.5264 94.2204V95.6238C37.5264 95.9668 37.7966 96.2475 38.1397 96.2475H64.5222C64.8548 96.2475 65.1355 95.9668 65.1355 95.6238V94.2204",
    stroke: "#1E1E1C",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4432 16.1642H40.9463L43.0669 15.9043H60.4265L62.4432 16.1642Z",
    stroke: "#1E1E1C",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoUltra);
export default __webpack_public_path__ + "static/media/pictoUltra.1b12b09f7babefda08c3bddfaa53ff29.svg";
export { ForwardRef as ReactComponent };